import { authAxios } from "@/axios/axios";
import { objectToFormData } from "@/helpers";

export async function getAnsweringMachine() {
    const { data } = await authAxios.get("v1/restaurants/current/answering-machine/");
    return data;
}

export async function patchAnsweringMachine(answeringMachine) {
    const { data } = await authAxios.patch(
        "v1/restaurants/current/answering-machine/", 
        answeringMachine,
    );
    return data;
}

export async function getAnsweringMachineCallSessions(params) {
    const { data } = await authAxios.get(
        "v1/restaurants/current/answering-machine/call-sessions/",
        {
            params,
        },
    );
    return data;
}

export async function getAnsweringMachineCallSession(id) {
    const { data } = await authAxios.get(
        `v1/restaurants/current/answering-machine/call-sessions/${id}/`,
    );
    return data;
}

export async function getAnsweringMachineCallSessionsCount(params) {
    const { data } = await authAxios.get(
        "v1/restaurants/current/answering-machine/call-sessions/count/",
        {
            params,
        },
    );
    return data;
}

export async function getAnsweringMachineCallSessionsIds(params) {
    const { data } = await authAxios.get(
        "v1/restaurants/current/answering-machine/call-sessions/ids/",
        {
            params,
        },
    );
    return data;
}

export async function deleteAnsweringMachineCallSession(id) {
    const { data } = await authAxios.delete(
        `v1/restaurants/current/answering-machine/call-sessions/${id}/`,
    );
    return data;
}

export async function patchAnsweringMachineCallSession({ id, ...callSession }) {
    const { data } = await authAxios.patch(
        `v1/restaurants/current/answering-machine/call-sessions/${id}/`,
        callSession,
    );
    return data;
}

export async function patchAnsweringMachineCallSessionBulk(payload) {
    const { data } = await authAxios.patch(
        `v1/restaurants/current/answering-machine/call-sessions/bulk/`,
        payload,
    );
    return data;
}

export async function deleteAnsweringMachineCallSessionBulk(payload) {
    const { data } = await authAxios.delete(
        `v1/restaurants/current/answering-machine/call-sessions/bulk/`,
        {
            data: payload,
        }
    );
    return data;
}

export async function getAnsweringMachinePhoneNumber() {
    const { data } = await authAxios.get("v1/restaurants/current/answering-machine/phone-number/");
    return data;
}

export async function postAnsweringMachinePhoneNumberOrder() {
    const { data } = await authAxios.post("v1/restaurants/current/answering-machine/phone-number/order/");
    return data;
}

export async function getAnsweringMachinePhoneNumberOrderRequirements() {
    const { data } = await authAxios.get("v1/restaurants/current/answering-machine/phone-number/order/requirements/");
    return data;
}

export async function patchAnsweringMachinePhoneNumberOrderRequirements(payload) {
    const { data } = await authAxios.patch("v1/restaurants/current/answering-machine/phone-number/order/requirements/", objectToFormData(payload));
    return data;
}


// WEBPACK FOOTER //
// ./src/features/answering-machine/queries/requests.js